import type { Disclosure } from "@/types/api";
import { http } from "./http";

/**
 * What a member is told about their organization seeing their activity, and
 * their acknowledgement of it.
 *
 * This is not optional polish. Named-employee reporting is defensible when the
 * person knows about it and indefensible when they do not — which is why the
 * People screen must not ship before this does.
 */
export const disclosureService = {
	get: (signal?: AbortSignal) =>
		http.get<Disclosure>("/api/org/disclosure", { signal }),

	acknowledge: () =>
		http.post<{ acknowledged_at: string }>("/api/org/disclosure/ack"),
};
